import { render } from "./radiobuttonInput.vue?vue&type=template&id=1c8e4b60&scoped=true"
import script from "./radiobuttonInput.vue?vue&type=script&lang=js"
export * from "./radiobuttonInput.vue?vue&type=script&lang=js"

import "./radiobuttonInput.vue?vue&type=style&index=0&id=1c8e4b60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8e4b60"]])

export default __exports__